export class OrganisationPermissionConstants {
  public static readonly READ_ORGANISATION = "readOrganisation";

  public static readonly READ_ORGANISATION_USERS = "readOrganisationUsers";

  public static readonly WRITE_ORGANISATION = "writeOrganisation";

  public static readonly WRITE_ORGANISATION_USERS = "writeOrganisationUsers";
}
